import { css } from "lit";

export const newCreateLinkModalStyles = css`
  .modal-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    overflow: auto;
  }

  .form-layout {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .premium-section {
    margin-top: var(--spacing-4, 1rem);
    padding-top: var(--spacing-4, 1rem);
    border-top: 1px solid var(--sds-color-border-default-default, #e0e0e0);
  }

  .loading-indicator {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-300);
    color: var(--sds-color-text-default-secondary);
    font-size: var(--sds-typography-body-size-small);
  }

  .spinner {
    animation: spin 1s linear infinite;
    color: var(--sds-color-text-brand-default);
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
